import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IElementBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/element-base-model.interface';
import { FrameConverter } from '@src/slide/domain/ui-model/converter/node-property/module-property/frame/frame-converter';
import { IBaseModel } from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import { ICopiedSdkData } from '@src/slide/domain/ui-model/element-modeles/property/copy/copy-model/paste-special.interface';
//  lodash部分引入
import _unset from 'lodash/unset';
import { cloneDeep, cloneDeepWith } from '@tencent/slide-sdk-model/src/utils/clone-deep';
import _set from 'lodash/set';
import { ICopySdkModelConfig } from '../../index.interface';
import { DataModel } from '@tencent/slide-sdk-model';

export interface IBaseCopySdkModel {
    getCopiedSdkModel(config?: ICopySdkModelConfig): ICopiedSdkData | undefined;
}

export class BaseCopySdkModel implements IBaseCopySdkModel {
    private model: IBaseModel;
    public constructor(model) {
        this.model = model;
    }

    public getCopiedSdkModel(config?: ICopySdkModelConfig): ICopiedSdkData | undefined {
        const cloneCustomizer = config?.cloneCustomizer;
        const sdkDataModel = this.model.sdkData as unknown as DataModel;

        const ownSdkData = config?.withoutOwnedData
            ? {}
            : this.copiedCloneDeep(sdkDataModel?.getOwnedData?.(), cloneCustomizer);

        const inheritedSdkData = config?.withoutInheritedData
            ? {}
            : this.copiedCloneDeep(sdkDataModel?.getInheritedData?.(), cloneCustomizer);

        return { inheritedSdkData, ownSdkData };
    }

    /**
     * 复制粘贴时使用的深拷贝
     * 使用 sdk 内部的深拷贝接口，在一般情况下性能优于 lodash
     */
    private copiedCloneDeep(value: any, cloneCustomizer?: ICopySdkModelConfig['cloneCustomizer']) {
        if (cloneCustomizer) {
            return cloneDeepWith(value, cloneCustomizer);
        }
        return cloneDeep(value);
    }
}

export class ElementBaseCopySdkModel extends BaseCopySdkModel {
    private elementBaseModel: IElementBaseModel;
    public constructor(model) {
        super(model);
        this.elementBaseModel = model;
    }

    /**
     * 复制时候使用的sdk model
     */
    public getCopiedSdkModel(config: ICopySdkModelConfig = {}) {
        return this.getEleCopiedSdkModelV3(config);
    }

    private getEleCopiedSdkModelV3(config: ICopySdkModelConfig = {}) {
        const allSdkData: any = super.getCopiedSdkModel(config);
        if (!allSdkData) return {};
        if (this.elementBaseModel.parent?.type === UIModelType.GROUP) {
            Object.values(allSdkData).forEach((sdkData) => {
                this.modifyChildInGroup(sdkData);
            });
        }
        // FIXME: Shape 的 placeholder 处理被单独提出在子类了，之后可以考虑合为一处
        // 图片、表格、图表复制后需要删除占位符属性
        if (config.isOriginal) {
            return allSdkData;
        }
        if (
            this.elementBaseModel.type === UIModelType.IMAGE
            || this.elementBaseModel.type === UIModelType.TABLE
            || this.elementBaseModel.type === UIModelType.CHART
        ) {
            Object.values(allSdkData).forEach((sdkData) => {
                // @ts-ignore
                _unset(sdkData.nvPr, 'ph');
            });
        }
        return allSdkData;
    }

    private modifyChildInGroup(cloneSdkData: any) {
        const frameOnSlide = this.elementBaseModel.getFrame?.().frameOnSlide();
        cloneSdkData.spPr.xfrm = FrameConverter.convertPartialDataFromUiToSdk(
            frameOnSlide,
            {
                scaleX: 1.0,
                scaleY: 1.0,
                left: 0,
                top: 0,
            },
            false,
        );
        this.copyGroupBg(this.elementBaseModel.sdkData, cloneSdkData);
    }

    private copyGroupBg(sdkData, cloneSdkData) {
        let curSdkData = sdkData;
        while (curSdkData?.store?.data?.spPr?.grpFill === true) {
            curSdkData = curSdkData.parent;
        }
        if (curSdkData && curSdkData !== sdkData) {
            ['solidFill', 'gradFill', 'blipFill', 'pattFill', 'noFill'].forEach((e) => {
                if (curSdkData.store?.data?.spPr?.[e]) {
                    _set(cloneSdkData, `spPr.${e}`, cloneDeep(curSdkData.store.data.spPr[e]));
                }
            });
        }
    }
}
